import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const SuccessText = styled(motion.h2)`
  font-size: 24px;
  font-weight: 600;
  color: #094c88;
  margin-top: 16px;
  text-align: center;
`;

const SuccessCheckmark = () => {
    return (
        <SuccessWrapper>
            <svg
                width="100"
                height="100"
                viewBox="0 0 52 52"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* The Circle */}
                <motion.circle
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                    stroke="#094c88"
                    strokeWidth="2"
                    initial={{ pathLength: 0, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                />
                {/* The Checkmark */}
                <motion.path
                    fill="none"
                    stroke="#094c88"
                    strokeWidth="4"
                    strokeLinecap="round"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    initial={{ pathLength: 0, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.5, ease: "easeOut" }}
                />
            </svg>
            <SuccessText
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1, duration: 0.4 }}
            >
                Payment Completed
            </SuccessText>
        </SuccessWrapper>
    );
};

export default SuccessCheckmark;
